import React from "react";
import {msalAuth} from "../../../../api/msal/MsalAuthProvider";
import $ from "jquery";
import * as GC from "../../../common/common";
import Table from "./Table";
import Detail from "./Detail";
import PlaatsDetailplanning from "./modal/plaatsDetailplanning";
import ColumnList from "../../../common/componet-jsons/column-list-mm.json";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as CommonFunctions from "./functions/commonFunctions";
import "./Variable/v";
import {CONSTS} from "../../../common/const";
import {GetSelected, SetSelected} from "../../../common/tableHandler/manipulateTable";
import {DropFromSetSelectedButtonIdsIfSelected, MergeUniquely} from "../../../common/function/functions";
import {GetDataForMapWithSetSelectedCallback} from "../../../common/map/showOnMap/showOnMap";
import { MAN_ME_CONST } from "../../../../constants/ActionEnums/ManActionEnums";

class Measures extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lastSendModel: {isRequired: false, model: []},
            error: null,
            height: window.innerHeight,
            token: null,
            columnList: [],
            columnListPure: [],
            columnOrderIdentification: "",
            columnOrderReference: "",
        };

    }

    async fillTable(model, page_number, customResult) {
        var that = this;
        window.$mm_measures_scroll_change = false;
        window.$mm_measures_lastUsedTableFilter = model;

        let result

        if (customResult && typeof customResult === 'object'){
            result = customResult
        } else {
            result  = await omnimap.FillTableAction(
                model,
                page_number,
                window.$mm_management_units_token
            );
        }

        CallBackFunctions.FillTableCallBack(
            result,
            page_number,
            window.$mm_measures_columnListPure
        );
    }

    /***TABLOLARIN SÜTÜN ARAMLARININ ANLIK YAPILMASINI SAĞLAYAN FONSİYON.***/
    searchFilterColumns(key, searchId) {
        var that = this;
        var model = {
            definitions: [process.env.REACT_APP_MM_MEASURES],
        };

        omnimap
            .SearchFilterColumnsAction(
                model,
                key,
                searchId,
                window.$mm_management_units_token
            )
            .then((result) => {
                CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    componentWillUnmount() {
    }

    ReloadData(page_number, ids, short_type, direction, field, content = []) {
        var model;

        if (!short_type) {
            if (ids && ids.length) {
                model = {
                    content: content,
                    context: [
                        {
                            role: "Beheeractiviteit zit in folder",
                            instance_identifiers: ids,
                            direction: "from",
                            and_or: "AND",
                            start: GC.GetDateTimeNow(),
                        },
                    ],
                    definitions: [process.env.REACT_APP_MM_MEASURES],
                    statuses: [],
                };
                window.$mm_measures_model_context = model.context;
                window.$mm_measures_lastUsedTableFilter = model;
            } else {
                model = {
                    content: content,
                    context: window.$mm_measures_model_context,
                    definitions: [process.env.REACT_APP_MM_MEASURES],
                    statuses: [],
                };
                window.$mm_measures_lastUsedTableFilter = model;
                window.$mm_management_units_result = [];
            }
        } else {
            if (ids && ids.length) {
                model = {
                    content: content,
                    context: [
                        {
                            role: "Beheeractiviteit zit in folder",
                            instance_identifiers: ids,
                            direction: "from",
                            and_or: "AND",
                            start: GC.GetDateTimeNow(),
                        },
                    ],
                    definitions: [process.env.REACT_APP_MM_MEASURES],
                    sorting: [
                        {
                            sort_type: short_type,
                            direction: direction,
                            field: field,
                        },
                    ],
                    statuses: [],
                };
                window.$mm_measures_model_context = model.context;

                window.$mm_measures_lastUsedTableFilter = model;
            } else {
                model = {
                    content: content,
                    context: window.$mm_measures_model_context,
                    definitions: [process.env.REACT_APP_MM_MEASURES],
                    sorting: [
                        {
                            sort_type: short_type,
                            direction: direction,
                            field: field,
                        },
                    ],
                };
                window.$mm_measures_lastUsedTableFilter = model;
            }
        }

        this.fillTable(model, page_number);

        this.fillFilterColumns([process.env.REACT_APP_MM_MEASURES]);
    }

    /*** --SERCH INPUTLARDA ARANAN DEĞERİ GETİREN FONKSİYON-- ****/
    addContentAndFillTable(key, value) {
        var hasRow = $.grep(window.$mm_measures_filterContent, function (v) {
            return v.key === key;
        });
        if (hasRow.length > 0) {
            window.$mm_measures_filterContent = $.grep(
                window.$mm_measures_filterContent,
                function (value) {
                    return value !== hasRow[0];
                }
            );
        }
        if (value != null) {
            var values = [];
            values.push(value);
            var contentModel = {
                and_or: "AND",
                datatype: "STRING",
                key: key,
                values: values,
            };
            window.$mm_measures_filterContent.push(contentModel);
        } else {
        }
        // var definitions = [];
        // let definition = window.$mm_measures_definitionList.filter(
        //   (def) => def["name"] === "maatregelen"
        // );
        // definitions.push(definition[0].id);
        var model = {
            content: window.$mm_measures_filterContent,
            definitions: [process.env.REACT_APP_MM_MEASURES],
        };
        this.setState({lastUsedTableFilter: model});

        this.ReloadData(
            1,
            window.$mm_management_units_result,
            null,
            null,
            null,
            window.$mm_measures_filterContent
        );
        // this.fillTable(model, 1);
    }

    async GetActionsOfRow(rowIds) {
        const actionList = await omnimap.GetActionsOfEndpointAction(MAN_ME_CONST.END_POINT)

        CallBackFunctions.GetActionsOfRowCallback(actionList);

        /* let result = await omnimap
            .GetActionsOfRowAction(rowIds, window.$mm_management_units_token)
            .catch((error) => {
                console.log(error);
            });

        CallBackFunctions.GetActionsOfRowCallback(result); */
    }

    fillFilterColumns(tableType) {
        var definitions = [];
        definitions.push(tableType);
        var model = {
            definitions: [process.env.REACT_APP_MM_MEASURES],
        };
        $.each(window.$mm_measures_columnList, async function (index, data) {
            if (data.id !== "") {
                let result = await omnimap
                    .FillFilterColumnsAction(
                        model,
                        data.id,
                        window.$mm_management_units_token
                    )
                    .catch((error) => {
                        console.log(error);
                    });
                CallBackFunctions.FillFilterColumnsCallBack(data, result);
            }
        });
    }

    //** propstan gelen tree veri̇si̇ i̇çeri̇si̇nde tiklanan li̇'ni̇n tüm alt dallarindaki̇ i̇dleri̇ geti̇ri̇r
    treeParser = (data, beheereenheid) => {
        const that = this;
        data.forEach(function (element) {
            if (element.parentfolder === beheereenheid) {
                window.$mm_measures_result.push(element.id);
                if (element.children.length > 0) {
                    that.treeParser(element.children, element.id);
                }
            } else if (element.children && element.children.length > 0) {
                that.treeParser(element.children, beheereenheid);
            }
        });
    };

    componentDidUpdate(prevProps, prevState) {
        const that = this;
        window.$mm_measures_page_number = 1;
        if (!that.props.location.state) {
            if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
                window.$mm_measures_model_context = [];
                var model = {
                    content: [],
                    definitions: [process.env.REACT_APP_MM_MEASURES],
                };
                // that.setState({ lastUsedTableFilter: model });
                that.ReloadData(1);
                document.getElementById("tree-parent-id").setAttribute("value", "");

                var treeClass = document.querySelector(".tree li.open.act");
                var treeDivClass = document.querySelector(".tree li div.open.act");
                if (treeClass !== null) {
                    treeClass.removeAttribute("class");
                }
                if (treeDivClass !== null) {
                    treeDivClass.classList.remove("open");
                    treeDivClass.classList.remove("act");
                }
            } else {
                $("#cover-spin").hide(0);
            }
        } else if (that.props.location.state && prevProps.location.state) {
            if (
                that.props.location.state.isDidUpdate !==
                prevProps.location.state.isDidUpdate
            ) {
                if (that.props.location.state.isDidUpdate == "0038") {
                    window.$mm_measures_model_context = [];
                    var model = {
                        content: [],
                        definitions: [process.env.REACT_APP_MM_MEASURES],
                    };
                    that.setState({lastUsedTableFilter: model});
                    that.ReloadData(1);
                } else {
                    window.$mm_measures_result = [];
                    window.$mm_measures_result.push(that.props.location.state.id);
                    this.treeParser(
                        that.props.location.state.TreeList,
                        that.props.location.state.id
                    );

                    var content = [
                        {
                            key: "maatregel-naam",
                            and_or: "AND",
                            values: [],
                            datatype: "STRING",
                        },
                    ];

                    that.ReloadData(
                        1,
                        window.$mm_measures_result,
                        null,
                        null,
                        null,
                        content
                    );
                }
            }
        } else {
            this.treeParser(
                that.props.location.state.TreeList,
                that.props.location.state.id
            );
            window.$mm_measures_result = [];
            window.$mm_measures_result.push(that.props.location.state.id);
            this.treeParser(
                that.props.location.state.TreeList,
                that.props.location.state.id
            );
            var content = [
                {
                    key: "maatregel-naam",
                    and_or: "AND",
                    values: [],
                    datatype: "STRING",
                },
            ];

            that.ReloadData(1, window.$mm_measures_result, null, null, null, content);

            $("#cover-spin").hide(0);
        }
    }

    handleShowSelectedButton() {
        window.$set_selected_button_selected_ids = [];
        window.$mm_setShowSelectedButtonOff();

        window.$mm_setShowSelectedButtonOnClick = () => {
            const selected = GetSelected();
            window.$set_selected_button_selected_ids = MergeUniquely(window.$set_selected_button_selected_ids, selected)

            if (!window.$mm_setShowSelectedButtonToggleState){
                window.window.$mm_measures_lastUsedTableFilter.instance_identifications = [];
            } else {
                window.window.$mm_measures_lastUsedTableFilter.instance_identifications = window.$set_selected_button_selected_ids;
            }

            this.fillTable(window.$mm_measures_lastUsedTableFilter,
                1,
                window.$set_selected_button_selected_ids.length === 0 && window.$mm_setShowSelectedButtonToggleState? CONSTS.EMPTY_TABLE_RESPONSE: null).then(()=>{
                SetSelected(window.$set_selected_button_selected_ids)
            });
        }
    }

    async componentDidMount() {
        var that = this;
        let callbackForSetSelectedFromMap = function (){};
        this.handleShowSelectedButton();
        /***************************************************************************************/
        /**FREE FORMAT */
        var tableHeaderItems;
        var userColumnResult = await omnimap.GetFreeFormatByIdAction(
            CONSTS.USER_ID_STORE
        );
        // userda column sort id'si varmı ?
        if (userColumnResult.meta.total_found == 0) {
            var user = window.localStorage.getItem("accessToken");
            window.$mm_management_units_column_order_users.client_identification =
                CONSTS.USER_ID_STORE;
            window.$mm_management_units_column_order_users.code =
                CONSTS.USER_ID_STORE;
            window.$mm_management_units_column_order_users.data.users.push({
                user_id: user.identification,
                id_stores: {
                    table_column_order: GC.uuidv4(),
                },
            });
            omnimap
                .GetFreeFormatAction(
                    "",
                    "POST",
                    window.$mm_management_units_column_order_users
                )
                .then(() => {
                    // GC.sleep(1500).then(() => this.fillTable());
                });
        }
        //userda column sort id'si var sa else geç
        else {
            let result = await omnimap.GetFreeFormatByIdAction(
                CONSTS.COLUMN_ORDER_MM_MEASURES
            );

            // bu sayfanın column sort'u var mı?
            if (result.meta.total_found == 0) {
                window.$mm_measures_column_order_post_model.client_identification =
                    CONSTS.COLUMN_ORDER_MM_MEASURES;
                window.$mm_measures_column_order_post_model.code =
                    CONSTS.COLUMN_ORDER_MM_MEASURES;

                omnimap
                    .GetFreeFormatAction(
                        "",
                        "POST",
                        window.$mm_measures_column_order_post_model
                    )
                    .then(() => {
                        window.location.reload();
                    });
            }
            // bu sayfanın column sort'u varsa else'e geç
            else {
                //burada sayfanın column sortları listenelinr ve table th sıralaması yapılır

                let result = await omnimap.GetFreeFormatByIdAction(
                    CONSTS.COLUMN_ORDER_MM_MEASURES,
                    "GET"
                );

                await this.setState({
                    columnOrderIdentification: result.data[0].identification,
                    columnOrderReference: result.data[0].reference,
                });

                result = await result.data[0].data.table_sorting.find(
                    (x) => x.name === "management-maintenance>measures"
                );

                tableHeaderItems = await result.column_list.map((item, index) =>
                    item === "checkbox" ? (
                        <th className="sorting_disabled">
                            <span className="checkAll"/>
                            <span className="checkNone" style={{display: "none"}}/>
                        </th>
                    ) : item === "measures" ? (
                        <th className="sorting_disabled" style={{width: "1%"}}>
                            <div id="short-table">
                                <div id="maatregelen-svg" className="maatregelen-svg"></div>
                                <div id="maatregelen-snowflake" className="snowflake"></div>
                            </div>
                        </th>
                    ) : item === "measures_plannig" ? (
                        <th className="sorting_disabled" style={{width: "1%"}}>
                            <div id="short-plannig">
                                <div id="plannig-svg" className="plannig-svg"></div>
                                <div id="plannig-snowflake" className="snowflake"></div>
                            </div>
                        </th>
                    ) : (
                        <th key={item}>{item}</th>
                    )
                );
                await this.setState({
                    columnList: tableHeaderItems,
                });
                window.$mm_measures_columnListPure = result;
            }
        }
        /***************************************************************************************/

        ColumnList.forEach(function (item) {
            if (item.name == "mm>measures") {
                window.$mm_measures_columnList = item["column-list"];
            }
        });

        if (window.$mm_management_units_token == null) {
            GC.GetToken().then((token) => {
                window.$mm_management_units_token = token;
                that.ReloadData(1);
            });
        } else that.ReloadData(1);

        /*****BEGIN FUNCTIONS BEGIN*****/

        function fillDetail() {
            $("#algemeenGisratioid").html(
                window.$mm_measures_selectedRow.algemeenGisratioid
            );
            $("#maatregelNaam").html(window.$mm_measures_selectedRow.maatregelNaam);
            $("#planningspatroon").html(
                window.$mm_measures_selectedRow.planningspatroon
            );
        }

        /*****END FUNCTIONS END*****/

        /*****BEGIN TABLE FUNCTIONS*****/
        var table = $("#example").DataTable({
            order: [],
            ordering: false,
            orderCellsTop: true,
            fixedHeader: true,
            searching: false,
            paging: false,
            scrollX: true, //"500px",

            scrollCollapse: true,
            scrollY: "calc(100vh - 330px)",

            dom: '<"top"if>t<"bottom"pr><"clear">',
            info: true,
            infoCallback: function (settings, start, end, max, total, pre) {
                return (
                    '<span class="select-item"></span>' +
                    '<span class="total_right"><span id="total-rows" class="total">' +
                    end +
                    "</span> geselecteerd </span>"
                );
            },
            language: {
                paginate: {
                    previous: "Eerste",
                    next: "Laatste",
                },
                select: {
                    rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
                },
            },
            columnDefs: [
                {
                    targets: 0,
                    data: null,
                    defaultContent: "",
                    orderable: false,
                    className: "select-checkbox",
                },
            ],
            select: {
                style: "multi+shift",
                selector: "tr",
            },
            // Disable sorting on the sorting_disabled class
            aoColumnDefs: [
                {
                    bSortable: false,
                    aTargets: ["sorting_disabled"],
                },
            ],
            colReorder: {
                fixedColumnsLeft: 1
            },
            stateSave: true,
            stateSaveCallback: (settings, data) => {
                let result = CallBackFunctions.TableColumnChangeHandler(
                    settings,
                    data,
                    that.state.columnOrderIdentification,
                    that.state.columnOrderReference,
                    CONSTS.COLUMN_ORDER_MM_MEASURES
                );
                window.$mm_measures_columnListPure = result;
            },
        });
        var lastScrollLeft = 0;
        var lastScrollControl = 0.33;
        var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0
        $(".dataTables_scrollBody").scroll(function () {
            var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();
            if (window.$mm_measures_scroll_change) {
                if (
                    $(".dataTables_scrollBody").prop("scrollHeight") -
                    $(".dataTables_scrollBody").scrollTop() <=
                    $(".dataTables_scrollBody").height() + buffer
                ) {
                    lastScrollControl = 0;
                }
            }
            if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
                if (window.$mm_measures_scroll_change) {
                    if (
                        $(".dataTables_scrollBody").prop("scrollHeight") -
                        $(".dataTables_scrollBody").scrollTop() <=
                        $(".dataTables_scrollBody").height() + buffer
                    ) {
                        if (document.getElementById("tableSide").className !== "d-none") {
                            if (
                                `/${this.baseURI.split("/")[3]}/${
                                    this.baseURI.split("/")[4]
                                }` === that.props.location.pathname &&
                                window.$mm_measures_table_total_row_count >
                                process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
                            ) {
                                $("#cover-spin").show(0);
                                window.$mm_measures_page_number++;
                                that.fillTable(
                                    window.$mm_measures_lastUsedTableFilter,
                                    window.$mm_measures_page_number
                                ).then(()=> {
                                    callbackForSetSelectedFromMap()
                                    window.$set_selected_button_selected_ids = MergeUniquely(window.$set_selected_button_selected_ids, callbackForSetSelectedFromMap())
                                });
                            }
                        } else window.$mm_measures_scroll_change = true;
                    }
                }
            }
        });

        /*** Setup - add a text input to each footer cell ***/
        $("#example thead tr").clone(true).appendTo("#example thead");

        $(table.table().header()).addClass("scrollabe-datatable");

        var tes = (document.getElementsByClassName(
            "scrollabe-datatable"
        )[0].parentElement.id = "scrollabe-datatable-id");
        $("#scrollabe-datatable-id thead tr")
            .clone(true)
            .appendTo("#scrollabe-datatable-id thead");

        /** columnList ile tablonun th'lerini karşılaştırır ve özellik işletir. */
        $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
            var title = $(this).text();
            if (title) {
                var row = $.grep(window.$mm_measures_columnList, function (v) {
                    return String(v.name).toLowerCase() === String(title).toLowerCase();
                });
                var rowId = row[0].id;
                if (row[0].filter == true) {
                    $(this).html(
                        '<input type="search" class="col-search" id="' + rowId + '" />'
                    );
                    $("input", this).on("keyup change", function () {
                        if (table.column(i).search() !== this.value) {
                            table.column(i).search(this.value).draw();
                        }
                    });
                } else {
                    $(this).html("");
                }
            } else if (this.innerHTML.includes("checkAll")) {
                $(this).html(
                    '<div class="popup threedots"><span class="popuptext" id="myPopup"><span class="popuptext" id="myPopup-plannig"></span></div>'
                );
            } else if (this.innerHTML.includes("maatregelen-svg")) {
                $(this).html(
                    '<div class="refresh"></div>' +
                    /**popup filter1 */
                    '<div class="filter-popup">' +
                    '  <span class="popuptext" id="short-table-popup" ></span>' +
                    "</div>" +
                    /**popup filter2 */
                    '<div class="filter-popup-plannig">' +
                    '  <span class="popuptext" id="short-table-popup-plannig" ></span>' +
                    "</div>" +
                    "<div>" +
                    '  <span id="maatregelen-tooltiptext" hidden>Maatregel actief</span>' +
                    "</div>"
                );
            } else {
                $(this).html("");
            }
        });
        /*** Server-Side Sorting ***/
        $("#scrollabe-datatable-id thead").on("click", "th", function () {
            var row_index = table.column(this).index();
            var nRow = $("#scrollabe-datatable-id thead tr")[0];

            if (
                row_index != undefined &&
                row_index != 0 &&
                row_index != 1 &&
                row_index != 2
            ) {
                if (
                    this.childNodes[0].className != "popup threedots" &&
                    this.childNodes[0].className != "refresh" &&
                    this.childNodes[0].className != "col-search ui-autocomplete-input" &&
                    this.childNodes[0].id != "short-table" &&
                    this.childNodes[0].id != "short-plannig"
                ) {
                    nRow.childNodes.forEach(function (indx) {
                        if (indx.cellIndex != row_index) {
                            indx.className = "sorting_disabled";
                        }
                    });

                    if (this.className == "sorting_disabled") {
                        this.className = "sorting_asc";
                        var row;
                        $.each(window.$mm_measures_columnList, function (index, data) {
                            if (data.row == row_index) {
                                row = data;
                            }
                        });

                        that.ReloadData(
                            1,
                            window.$mm_management_units_result,

                            row.shortType,
                            "ASCENDING",
                            row.shortField,
                            window.$mm_measures_filterContent
                        );
                    } else if (this.className == "sorting_asc") {
                        this.className = "sorting_desc";
                        var row;
                        $.each(window.$mm_measures_columnList, function (index, data) {
                            if (data.row == row_index) {
                                row = data;
                            }
                        });
                        that.ReloadData(
                            1,
                            window.$mm_management_units_result,

                            row.shortType,
                            "DESCENDING",
                            row.shortField,
                            window.$mm_measures_filterContent
                        );
                    } else if (this.className == "sorting_desc") {
                        this.className = "sorting_asc";
                        var row;
                        $.each(window.$mm_measures_columnList, function (index, data) {
                            if (data.row == row_index) {
                                row = data;
                            }
                        });
                        that.ReloadData(
                            1,
                            window.$mm_management_units_result,

                            row.shortType,
                            "ASCENDING",
                            row.shortField,
                            window.$mm_measures_filterContent
                        );
                    }

                    window.$mm_measures_page_number = 1;
                }
            }
        });

        $("#example tbody").on("click", "tr", function () {
            if ($(".checkAll").attr("style") == "display: none;") {
                $(".checkNone, .checkAll").toggle();
            }
            DropFromSetSelectedButtonIdsIfSelected(this);
        });

        //** select all table
        $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
            var table = $("#example").DataTable();
            table.rows().select();

            $(".checkNone, .checkAll").toggle();
        });

        //** unselect all table
        $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
            var table = $("#example").DataTable();

            table.rows().deselect();
            $(".checkNone, .checkAll").toggle();
            window.$set_selected_button_selected_ids = []
        });

        $("#example_filter input").addClass("search-input-table1");
        $(".search-input-table1").attr("placeholder", "search text");

        /*** Table Row Double Click ***/
        $("#example tbody").on("dblclick", "tr", function () {
            // var rowId = this.children[3].innerText;
            var rowId = $(this).attr("rowId");

            $.each(window.$mm_measures_Glist, function (index, data) {
                if (data.identification == rowId) {
                    window.$mm_measures_selectedRow = data;
                }
            });

            fillDetail();
            $("#tableSide").addClass("d-none");
            $("#detailSide").removeClass("d-none");
        });

        /*** Option to allow selecting rows by clicking on row besides checkbox. ***/
        // $("#example tbody").on("click", "tr", function () {
        //   $(this).toggleClass("selected");
        // });

        /*** Search İnput ***/
        $(".col-search").on("input", function (e) {
            if (this.value === "") {
                that.addContentAndFillTable($(this).attr("id"), null);
            }
        });

        /*** Table Columns Add Html Element*/
        table.columns().iterator("column", function (ctx, idx) {
            if (
                window.$mm_measures_columnListPure.column_list[idx] === "checkbox" ||
                window.$mm_measures_columnListPure.column_list[idx] === "measures" ||
                window.$mm_measures_columnListPure.column_list[idx] ===
                "measures_plannig"
            ) {
            } else {
                $(table.column(idx).header()).append('<span class="sort-icon"/>');
            }
        });

        /*****END TABLE FUNCTIONS*****/

        /*****BEGIN TABLE SEARCH AUTOCOMPLETE BEGIN*****/
        $("#algemeen-gisratio").autocomplete({
            source: window.$mm_measures_algemeenGisratioid,
            select: function (event, ui) {
                that.addContentAndFillTable("algemeen-gisratio", ui.item.value);
            },
            open: function (e, ui) {
                $(".ui-autocomplete").css(
                    "top",
                    $("ul.ui-autocomplete").cssUnit("top")[0] + 2
                );
            },
        });
        $("#maatregel-naam").autocomplete({
            source: window.$mm_measures_maatregelNaam,
            select: function (event, ui) {
                that.addContentAndFillTable("maatregel-naam", ui.item.value);
            },
            open: function (e, ui) {
                $(".ui-autocomplete").css(
                    "top",
                    $("ul.ui-autocomplete").cssUnit("top")[0] + 2
                );
            },
        });
        $("#planningspatroon-naam").autocomplete({
            source: window.$mm_measures_planningspatroonNaam,
            select: function (event, ui) {
                that.addContentAndFillTable("planningspatroon-naam", ui.item.value);
            },
            open: function (e, ui) {
                $(".ui-autocomplete").css(
                    "top",
                    $("ul.ui-autocomplete").cssUnit("top")[0] + 2
                );
            },
        });
        $("#planningsperiode-naam").autocomplete({
            source: window.$mm_measures_planningsperiodeNaam,
            select: function (event, ui) {
                that.addContentAndFillTable("planningsperiode-naam", ui.item.value);
            },
            open: function (e, ui) {
                $(".ui-autocomplete").css(
                    "top",
                    $("ul.ui-autocomplete").cssUnit("top")[0] + 2
                );
            },
        });

        $("#algemeen-gisratio").on("input", function () {
            // window.$mm_measures_algemeenGisratioid.length = 0;
            that.searchFilterColumns($(this).val(), this.id);
            // get the current value of the input field.
        });
        $("#maatregel-naam").on("input", function () {
            // window.$mm_measures_maatregelNaam.length = 0;
            that.searchFilterColumns($(this).val(), this.id);
            // get the current value of the input field.
        });
        $("#planningspatroon-naam").on("input", function () {
            // window.$mm_measures_planningspatroonNaam.length = 0;
            that.searchFilterColumns($(this).val(), this.id);
            // get the current value of the input field.
        });
        $("#planningsperiode-naa").on("input", function () {
            // window.$mm_measures_planningsperiodeNaam.length = 0;
            that.searchFilterColumns($(this).val(), this.id);
            // get the current value of the input field.
        });
        /*****END TABLE SEARCH AUTOCOMPLETE END*****/

        /*****BEGIN --FILTER ICON CLICK--- BEGIN*****/
        $("#short-table").click(function () {
            if (!window.$mm_measures_filterClickStatus) {
                $("#myPopup").html("");
                $("#short-table-popup").html("");

                var filterRowActive = $('<div id="m-filter-input-true"></div>')
                    .attr({name: "true"})
                    .addClass("filter-popup-r")
                    .html(
                        '<label class="filter-container">Filter op met maatregel' +
                        '<input type="checkbox" >' +
                        '<span class="checkmark-green"></span>' +
                        "</label>"
                    );

                var filterRowFalse = $('<div id="m-filter-input-false"></div>')
                    .attr({name: "false"})
                    .addClass("filter-popup-r")
                    .html(
                        '<label class="filter-container">Filter op zonder maatregel' +
                        '<input type="checkbox" >' +
                        '<span class="checkmark-red"></span>' +
                        "</label>"
                    );
                $("#short-table-popup").append(filterRowActive, filterRowFalse);
                window.$mm_measures_filterClickStatus = true;
            }

            var popup = document.getElementById("short-table-popup");
            popup.classList.toggle("show");
        });
        $("#short-plannig").click(function () {
            if (!window.$mm_measures_filterClickStatusPlannig) {
                $("#myPopup-plannig").html("");
                $("#short-table-popup-plannig").html("");
                var filterRowActive = $('<div id="plannig-filter-input-true"></div>')
                    .attr({name: "true"})
                    .addClass("filter-popup-r")
                    .html(
                        '<label class="filter-container">Filter op met maatregel' +
                        '<input type="checkbox" >' +
                        '<span class="checkmark-green"></span>' +
                        "</label>"
                    );

                var filterRowFalse = $('<div id="plannig-filter-input-false"></div>')
                    .attr({name: "false"})
                    .addClass("filter-popup-r")
                    .html(
                        '<label class="filter-container">Filter op zonder maatregel' +
                        '<input type="checkbox" >' +
                        '<span class="checkmark-red"></span>' +
                        "</label>"
                    );
                $("#short-table-popup-plannig").append(filterRowActive, filterRowFalse);
                window.$mm_measures_filterClickStatusPlannig = true;
            }

            var popup = document.getElementById("short-table-popup-plannig");
            popup.classList.toggle("show");
        });
        /*****END FILTER ICON CLICK END*****/

        /*****BEGIN FILTER MAATREGELEN CHECKBOX FUNCTIONS  BEGIN*****/
        $(document).on("click", "div#m-filter-input-true", function () {
            if (window.$mm_measures_gvv == 0) {
                window.$mm_measures_filterCheckControlMaat[0] =
                    !window.$mm_measures_filterCheckControlMaat[0];
                window.$mm_measures_filterCheckControlMaat[1] = false;

                if (
                    !window.$mm_measures_filterCheckControlMaat[0] &&
                    !window.$mm_measures_filterCheckControlMaat[1]
                ) {
                    if (
                        !window.$mm_measures_filterCheckControlPlann[0] &&
                        !window.$mm_measures_filterCheckControlPlann[1] &&
                        !window.$mm_measures_filterCheckControlMaat[0] &&
                        !window.$mm_measures_filterCheckControlMaat[1]
                    ) {
                        that.ReloadData(1);
                        window.$mm_measures_gvv++;
                        $("#maatregelen-svg").attr("class", "maatregelen-svg");
                        $("#maatregelen-snowflake").attr("class", "snowflake");
                    } else {
                        $("#maatregelen-svg").attr("class", "maatregelen-svg");
                        $("#maatregelen-snowflake").attr("class", "snowflake");
                        window.$mm_measures_gvv++;

                        var hasRow = $.grep(
                            window.$mm_measures_filterContent,
                            function (v) {
                                if (v.values[0] == false) {
                                    return v.key === "maatregel-actief";
                                }
                            }
                        );
                        if (hasRow.length > 0) {
                            window.$mm_measures_filterContent = $.grep(
                                window.$mm_measures_filterContent,
                                function (item) {
                                    if (item.values[0] == true) {
                                        return item !== hasRow[0];
                                    }
                                }
                            );
                        }

                        that.ReloadData(
                            1,
                            null,
                            null,
                            null,
                            null,
                            window.$mm_measures_filterContent
                        );
                    }
                } else {
                    document.getElementById("m-filter-input-false").remove();

                    $("#maatregelen-svg").attr("class", "maatregelen-svg-green");
                    $("#maatregelen-snowflake").attr("class", "snowflake-green");
                    var filterRowFalse = $('<div id="m-filter-input-false""></div>')
                        .attr({name: "false"})
                        .addClass("filter-popup-r")
                        .html(
                            '<label class="filter-container">Filter op zonder maatregel' +
                            '<input type="checkbox" id="m-filter-input-false">' +
                            '<span class="checkmark-red"></span>' +
                            "</label>"
                        );
                    $("#short-table-popup").append(filterRowFalse);
                    window.$mm_measures_gvv++;
                    window.$mm_measures_filterMaatregelenIsActive = [true];

                    var hasRow = $.grep(window.$mm_measures_filterContent, function (v) {
                        if (v.values[0] == false) {
                            return v.key === "maatregel-actief";
                        }
                    });
                    if (hasRow.length > 0) {
                        window.$mm_measures_filterContent = $.grep(
                            window.$mm_measures_filterContent,
                            function (item) {
                                if (item.values[0] == false) {
                                    return item !== hasRow[0];
                                }
                            }
                        );
                    }

                    var model = {
                        key: "maatregel-actief",
                        and_or: "AND",
                        values: window.$mm_measures_filterMaatregelenIsActive,
                        datatype: "BOOLEAN",
                    };
                    window.$mm_measures_filterContent.push(model);

                    that.ReloadData(
                        1,
                        null,
                        null,
                        null,
                        null,
                        window.$mm_measures_filterContent
                    );
                }
            }
        });
        $(document).on("click", "div#m-filter-input-false", function () {
            if (window.$mm_measures_gvv == 0) {
                window.$mm_measures_filterCheckControlMaat[1] =
                    !window.$mm_measures_filterCheckControlMaat[1];
                window.$mm_measures_filterCheckControlMaat[0] = false;

                if (
                    !window.$mm_measures_filterCheckControlMaat[0] &&
                    !window.$mm_measures_filterCheckControlMaat[1]
                ) {
                    if (
                        !window.$mm_measures_filterCheckControlPlann[0] &&
                        !window.$mm_measures_filterCheckControlPlann[1] &&
                        !window.$mm_measures_filterCheckControlMaat[0] &&
                        !window.$mm_measures_filterCheckControlMaat[1]
                    ) {
                        that.ReloadData(1);
                        window.$mm_measures_gvv++;
                        $("#maatregelen-svg").attr("class", "maatregelen-svg");
                        $("#maatregelen-snowflake").attr("class", "snowflake");
                    } else {
                        $("#maatregelen-svg").attr("class", "maatregelen-svg");
                        $("#maatregelen-snowflake").attr("class", "snowflake");
                        window.$mm_measures_gvv++;

                        var hasRow = $.grep(
                            window.$mm_measures_filterContent,
                            function (v) {
                                if (v.values[0] == false) {
                                    return v.key === "maatregel-actief";
                                }
                            }
                        );
                        if (hasRow.length > 0) {
                            window.$mm_measures_filterContent = $.grep(
                                window.$mm_measures_filterContent,
                                function (item) {
                                    if (item.values[0] == false) {
                                        return item !== hasRow[0];
                                    }
                                }
                            );
                        }

                        that.ReloadData(
                            1,
                            null,
                            null,
                            null,
                            null,
                            window.$mm_measures_filterContent
                        );
                    }
                } else {
                    document.getElementById("m-filter-input-true").remove();

                    $("#maatregelen-svg").attr("class", "maatregelen-svg-red");
                    $("#maatregelen-snowflake").attr("class", "snowflake-red");
                    var filterRowActive = $('<div id="m-filter-input-true"></div>')
                        .attr({name: "true"})
                        .addClass("filter-popup-r")
                        .html(
                            '<label class="filter-container">Filter op met maatregel' +
                            '<input type="checkbox" >' +
                            '<span class="checkmark-green"></span>' +
                            "</label>"
                        );

                    $("#short-table-popup").prepend(filterRowActive);
                    window.$mm_measures_gvv++;
                    window.$mm_measures_filterMaatregelenIsActive = [false];

                    var hasRow = $.grep(window.$mm_measures_filterContent, function (v) {
                        if (v.values[0] == true) {
                            return v.key === "maatregel-actief";
                        }
                    });
                    if (hasRow.length > 0) {
                        window.$mm_measures_filterContent = $.grep(
                            window.$mm_measures_filterContent,
                            function (item) {
                                if (item.values[0] == false) {
                                    return item !== hasRow[0];
                                }
                            }
                        );
                    }

                    var model = {
                        key: "maatregel-actief",
                        and_or: "AND",
                        values: window.$mm_measures_filterMaatregelenIsActive,
                        datatype: "BOOLEAN",
                    };
                    window.$mm_measures_filterContent.push(model);

                    that.ReloadData(
                        1,
                        null,
                        null,
                        null,
                        null,
                        window.$mm_measures_filterContent
                    );
                }
            }
        });
        /*****END FILTER MAATREGELEN CHECKBOX FUNCTIONS END*****/

        /*****BEGIN FILTER PLANNIG CHECKBOX FUNCTIONS BEGIN*****/
        $(document).on("click", "div#plannig-filter-input-true", function () {
            if (window.$mm_measures_gvv == 0) {
                window.$mm_measures_filterCheckControlPlann[0] =
                    !window.$mm_measures_filterCheckControlPlann[0];
                window.$mm_measures_filterCheckControlPlann[1] = false;

                if (
                    !window.$mm_measures_filterCheckControlPlann[0] &&
                    !window.$mm_measures_filterCheckControlPlann[1]
                ) {
                    if (
                        !window.$mm_measures_filterCheckControlPlann[0] &&
                        !window.$mm_measures_filterCheckControlPlann[1] &&
                        !window.$mm_measures_filterCheckControlMaat[0] &&
                        !window.$mm_measures_filterCheckControlMaat[1]
                    ) {
                        that.ReloadData(1);
                        window.$mm_measures_gvv++;
                        $("#plannig-svg").attr("class", "plannig-svg");
                        $("#plannig-snowflake").attr("class", "snowflake");
                    } else {
                        $("#plannig-svg").attr("class", "plannig-svg");
                        $("#plannig-snowflake").attr("class", "snowflake");
                        window.$mm_measures_gvv++;

                        var hasRow = $.grep(
                            window.$mm_measures_filterContent,
                            function (v) {
                                if (v.values[0] == true) {
                                    return v.key === "status-globaleplanning";
                                }
                            }
                        );
                        if (hasRow.length > 0) {
                            window.$mm_measures_filterContent = $.grep(
                                window.$mm_measures_filterContent,
                                function (item) {
                                    if (item.values[0] == false) {
                                        return item !== hasRow[0];
                                    }
                                }
                            );
                        }
                        that.ReloadData(
                            1,
                            null,
                            null,
                            null,
                            null,
                            window.$mm_measures_filterContent
                        );
                    }
                } else {
                    document.getElementById("plannig-filter-input-false").remove();

                    $("#plannig-svg").attr("class", "plannig-svg-green");
                    $("#plannig-snowflake").attr("class", "snowflake-green");
                    var filterRowFalse = $('<div id="plannig-filter-input-false""></div>')
                        .attr({name: "false"})
                        .addClass("filter-popup-r")
                        .html(
                            '<label class="filter-container">Filter op zonder maatregel' +
                            '<input type="checkbox" id="m-filter-input-false">' +
                            '<span class="checkmark-red"></span>' +
                            "</label>"
                        );
                    $("#short-table-popup-plannig").append(filterRowFalse);
                    window.$mm_measures_gvv++;
                    that.filterPlannigIsActive = [true];

                    var hasRow = $.grep(window.$mm_measures_filterContent, function (v) {
                        if (v.values[0] == false) {
                            return v.key === "status-globaleplanning";
                        }
                    });
                    if (hasRow.length > 0) {
                        window.$mm_measures_filterContent = $.grep(
                            window.$mm_measures_filterContent,
                            function (item) {
                                if (item.values[0] == false) {
                                    return item !== hasRow[0];
                                } else if (item.values[0] == true) {
                                    return item !== hasRow[0];
                                }
                            }
                        );
                    }
                    var content = {
                        key: "status-globaleplanning",
                        and_or: "AND",
                        values: that.filterPlannigIsActive,
                        datatype: "BOOLEAN",
                    };
                    window.$mm_measures_filterContent.push(content);

                    that.ReloadData(
                        1,
                        null,
                        null,
                        null,
                        null,
                        window.$mm_measures_filterContent
                    );
                }
            }
        });

        $(document).on("click", "div#plannig-filter-input-false", function () {
            if (window.$mm_measures_gvv == 0) {
                window.$mm_measures_filterCheckControlPlann[1] =
                    !window.$mm_measures_filterCheckControlPlann[1];
                window.$mm_measures_filterCheckControlPlann[0] = false;

                if (
                    !window.$mm_measures_filterCheckControlPlann[0] &&
                    !window.$mm_measures_filterCheckControlPlann[1]
                ) {
                    if (
                        !window.$mm_measures_filterCheckControlPlann[0] &&
                        !window.$mm_measures_filterCheckControlPlann[1] &&
                        !window.$mm_measures_filterCheckControlMaat[0] &&
                        !window.$mm_measures_filterCheckControlMaat[1]
                    ) {
                        that.ReloadData(1);
                        window.$mm_measures_gvv++;
                        $("#plannig-svg").attr("class", "plannig-svg");
                        $("#plannig-snowflake").attr("class", "snowflake");
                    } else {
                        $("#plannig-svg").attr("class", "plannig-svg");
                        $("#plannig-snowflake").attr("class", "snowflake");
                        window.$mm_measures_gvv++;

                        var hasRow = $.grep(
                            window.$mm_measures_filterContent,
                            function (v) {
                                if (v.values[0] == false) {
                                    return v.key === "status-globaleplanning";
                                }
                            }
                        );
                        if (hasRow.length > 0) {
                            window.$mm_measures_filterContent = $.grep(
                                window.$mm_measures_filterContent,
                                function (item) {
                                    if (item.values[0] == false) {
                                        return item !== hasRow[0];
                                    }
                                }
                            );
                        }

                        that.ReloadData(
                            1,
                            null,
                            null,
                            null,
                            null,
                            window.$mm_measures_filterContent
                        );
                    }
                } else {
                    document.getElementById("plannig-filter-input-true").remove();

                    $("#plannig-svg").attr("class", "plannig-svg-red");
                    $("#plannig-snowflake").attr("class", "snowflake-red");
                    var filterRowActive = $('<div id="plannig-filter-input-true"></div>')
                        .attr({name: "true"})
                        .addClass("filter-popup-r")
                        .html(
                            '<label class="filter-container">Filter op met maatregel' +
                            '<input type="checkbox" >' +
                            '<span class="checkmark-green"></span>' +
                            "</label>"
                        );

                    $("#short-table-popup-plannig").prepend(filterRowActive);
                    window.$mm_measures_gvv++;
                    that.filterPlannigIsActive = [false];

                    var hasRow = $.grep(window.$mm_measures_filterContent, function (v) {
                        if (v.values[0] == true) {
                            return v.key === "status-globaleplanning";
                        }
                    });
                    if (hasRow.length > 0) {
                        window.$mm_measures_filterContent = $.grep(
                            window.$mm_measures_filterContent,
                            function (item) {
                                if (item.values[0] == false) {
                                    return item !== hasRow[0];
                                } else if (item.values[0] == true) {
                                    return item !== hasRow[0];
                                }
                            }
                        );
                    }

                    var content = {
                        key: "status-globaleplanning",
                        and_or: "AND",
                        values: that.filterPlannigIsActive,
                        datatype: "BOOLEAN",
                    };

                    window.$mm_measures_filterContent.push(content);

                    that.ReloadData(
                        1,
                        null,
                        null,
                        null,
                        null,
                        window.$mm_measures_filterContent
                    );
                }
            }
        });
        /*****END FILTER PLANNIG CHECKBOX FUNCTIONS END*****/

        /** ekranın herhangi biryerine tıklanınca popup kaldırma için kullanılan fonksiyon */
        $(document)
            .unbind("mouseup")
            .mouseup(function (e) {
                var popup = $("#myPopup");
                if (
                    !$("div.popup").is(e.target) &&
                    !popup.is(e.target) &&
                    popup.has(e.target).length === 0
                ) {
                    $("#myPopup").html("");
                    var popup = document.getElementById("myPopup");
                    $("#myPopup").removeClass("show");
                }
                var popup = $("#short-table-popup");
                if (
                    !$("div.filter-popup").is(e.target) &&
                    !popup.is(e.target) &&
                    popup.has(e.target).length === 0
                ) {
                    // $("#short-table-popup").html("");
                    var popup = document.getElementById("short-table-popup");
                    $("#short-table-popup").removeClass("show");
                }
                var popup = $("#short-table-popup-plannig");
                if (
                    !$("div.filter-popup-plannig").is(e.target) &&
                    !popup.is(e.target) &&
                    popup.has(e.target).length === 0
                ) {
                    // $("#short-table-popup-plannig").html("");
                    var popup = document.getElementById("short-table-popup-plannig");
                    $("#short-table-popup-plannig").removeClass("show");
                }
            });

        // $("#short-table").on({
        //   mouseenter: function () {
        //     document.getElementById("maatregelen-tooltiptext").hidden = false;
        //   },
        //   mouseleave: function () {
        //     document.getElementById("maatregelen-tooltiptext").hidden = true;
        //   },
        // });


        // function getDataForMap() {
        //     callbackForSetSelectedFromMap = FeatureListenerCallback(undefined, (rows) => {
        //         window.$set_selected_button_selected_ids = rows;
        //     })
        //
        //     var model = window.$mm_measures_lastUsedTableFilter;
        //     var locations = [];
        //     var highlightedIds = [];
        //
        //     omnimap
        //         .GetDataForMapAction(model, window.$mm_management_units_token)
        //         .then((result) => {
        //             if (result.data.length > 0) {
        //                 var selectedIds = [];
        //                 $("#example")
        //                     .dataTable()
        //                     .$("tr.selected")
        //                     .each(function () {
        //                         selectedIds.push($(this).attr("rowId"));
        //                     });
        //
        //                 for (const data of result.data) {
        //                     locations.push(data.location);
        //                     if (selectedIds.includes(data.identification)) {
        //                         for (var i = 0; i < data.location.features.length; i++) {
        //                             highlightedIds.push(
        //                                 data.location.features[i].properties.identifier
        //                             );
        //                         }
        //                     }
        //                 }
        //                 if (window.$mm_measures_webgisId == "") {
        //                     window.$mm_measures_webgisId = uuidv4();
        //                     var win = window.open(
        //                         "/gispublisher.html?webgisId=" + window.$mm_measures_webgisId,
        //                         "_blank"
        //                     );
        //                     /* $(win).ready(function () {
        //                       $(win.document).on("click", "#mommy", async function () {
        //                         await localStorage.setItem("webgis", "");
        //                         await localStorage.setItem(
        //                           "webgis",
        //                           JSON.stringify({
        //                             type: "addFeatures",
        //                             locations: locations,
        //                           })
        //                         );
        //
        //                         await localStorage.setItem("webgis", "");
        //                         await localStorage.setItem(
        //                           "webgis",
        //                           JSON.stringify({
        //                             type: "highlightFeatures",
        //                             featureIds: highlightedIds,
        //                           })
        //                         );
        //                       });
        //                     }); */
        //                     localStorage.setItem(
        //                         "webgis",
        //                         JSON.stringify({
        //                             type: "addFeatures",
        //                             locations: locations,
        //                             featureIds: highlightedIds,
        //                         })
        //                     );
        //                 } else {
        //                     /* localStorage.setItem("webgis", "");
        //                     localStorage.setItem(
        //                       "webgis",
        //                       JSON.stringify({ type: "addFeatures", locations: locations })
        //                     );
        //
        //                     localStorage.setItem("webgis", "");
        //                     localStorage.setItem(
        //                       "webgis",
        //                       JSON.stringify({
        //                         type: "highlightFeatures",
        //                         featureIds: highlightedIds,
        //                       })
        //                     ); */
        //                     localStorage.setItem("webgis", "");
        //                     localStorage.setItem(
        //                         "webgis",
        //                         JSON.stringify({
        //                             type: "addFeatures",
        //                             locations: locations,
        //                             featureIds: highlightedIds,
        //                         })
        //                     );
        //                 }
        //             }
        //         });
        // }

        $(document).on("click", ".mm-measures-action", function () {
            var actionId = $(this).attr("id");

            if (actionId === "measures_toon_dossiers_op_kaart") {
                callbackForSetSelectedFromMap =  GetDataForMapWithSetSelectedCallback(window.$mm_measures_lastUsedTableFilter, "measures");
            } else {
                let modalId = window.$mm_measures_actions.filter(
                    (act) => act["id"] === actionId
                )[0]["modal"];
                $("#" + modalId).modal("show");
            }
        });

        $(document).on("click", ".showMap", function () {
            if (window.$mm_measures_webgisId === "") {
                window.$mm_measures_webgisId = uuidv4();
                var win = window.open(
                    "/gispublisher.html?webgisId=" + window.$mm_measures_webgisId,
                    "_blank"
                );
                $(win).ready(function () {
                    localStorage.setItem("webgis", "test3");
                });
            }
            localStorage.setItem("webgis", "test3");
        });

        function uuidv4() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function (c) {
                    var r = (Math.random() * 16) | 0,
                        v = c === "x" ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                }
            );
        }

        function refreshFunction() {

            $("#cover-spin").show(0);
            $("#maatregelen-svg").attr("class", "maatregelen-svg");
            $("#maatregelen-snowflake").attr("class", "snowflake");
            $("#plannig-svg").attr("class", "plannig-svg");
            $("#plannig-snowflake").attr("class", "snowflake");

            window.$mm_measures_page_number = 1;
            if (document.getElementById("m-filter-input-false")) {
                document.getElementById("m-filter-input-false").remove();
                var filterRowFalse = $('<div id="m-filter-input-false""></div>')
                    .attr({name: "false"})
                    .addClass("filter-popup-r")
                    .html(
                        '<label class="filter-container">Filter op zonder maatregel' +
                        '<input type="checkbox" id="m-filter-input-false">' +
                        '<span class="checkmark-red"></span>' +
                        "</label>"
                    );
                $("#short-table-popup").append(filterRowFalse);
            }
            if (document.getElementById("m-filter-input-true")) {
                document.getElementById("m-filter-input-true").remove();
                var filterRowActive = $('<div id="m-filter-input-true"></div>')
                    .attr({name: "true"})
                    .addClass("filter-popup-r")
                    .html(
                        '<label class="filter-container">Filter op met maatregel' +
                        '<input type="checkbox" >' +
                        '<span class="checkmark-green"></span>' +
                        "</label>"
                    );
                $("#short-table-popup").prepend(filterRowActive);
            }

            if (document.getElementById("plannig-filter-input-false")) {
                document.getElementById("plannig-filter-input-false").remove();
                var filterRowFalse = $('<div id="plannig-filter-input-false""></div>')
                    .attr({name: "false"})
                    .addClass("filter-popup-r")
                    .html(
                        '<label class="filter-container">Filter op zonder maatregel' +
                        '<input type="checkbox" id="m-filter-input-false">' +
                        '<span class="checkmark-red"></span>' +
                        "</label>"
                    );
                $("#short-table-popup-plannig").append(filterRowFalse);
            }

            if (document.getElementById("plannig-filter-input-true")) {
                document.getElementById("plannig-filter-input-true").remove();
                var filterRowActive = $('<div id="plannig-filter-input-true"></div>')
                    .attr({name: "true"})
                    .addClass("filter-popup-r")
                    .html(
                        '<label class="filter-container">Filter op met maatregel' +
                        '<input type="checkbox" >' +
                        '<span class="checkmark-green"></span>' +
                        "</label>"
                    );
                $("#short-table-popup-plannig").prepend(filterRowActive);
            }
            // to clean all filters before refresh
            window.$mm_measures_model_context = [];
            // that.ReloadData(1, null, null, null, null, []);
            that.fillTable(window.$mm_measures_lastUsedTableFilter, 1);
        }

        window.$mm_measures_refreshFunction = refreshFunction;

        $(".refresh").click(refreshFunction);


        $(".back-page-link").click(function () {
            $("#tableSide").removeClass("d-none");
            $("#detailSide").addClass("d-none");
        });

        $("div.popup").click(function () {
            var selectedIds = [];
            $("#example")
                .dataTable()
                .$("tr.selected")
                .each(function () {
                    selectedIds.push($(this).attr("rowId"));
                });
            that.GetActionsOfRow(selectedIds.join(","));
            window.$mm_measures_selectedIds = selectedIds;
        });
    }

    render() {
        return (
            <div>
                <div id="cover-spin"></div>
                <div className="border p-3 br5 full-width" id="border-mid">
                    <div id="tableSide">
                        <table id="example" className="table-hover table min-full-width">
                            <thead>
                            <tr>
                                {this.state.columnList}
                                {/* <th className="sorting_disabled" style={{ width: "1%" }}>
                    <span className="checkAll" />
                    <span className="checkNone" style={{ display: "none" }} />
                  </th>
                  <th className="sorting_disabled" style={{ width: "1%" }}>
                    <div id="short-table">
                      <div
                        id="maatregelen-svg"
                        className="maatregelen-svg"
                      ></div>
                      <div
                        id="maatregelen-snowflake"
                        className="snowflake"
                      ></div>
                    </div>
                  </th>
                  <th className="sorting_disabled" style={{ width: "1%" }}>
                    <div id="short-plannig">
                      <div id="plannig-svg" className="plannig-svg"></div>
                      <div id="plannig-snowflake" className="snowflake"></div>
                    </div>
                  </th>
                  <th>Gisratio ID</th>
                  <th>Maatregel</th>
                  <th>Planningspatroon</th>
                  <th>Planningsperiode</th> */}
                            </tr>
                            </thead>
                            <tbody></tbody>
                        </table>
                        <input id="tree-parent-id" hidden/>
                        <input id="tree-parent-name" hidden/>
                    </div>
                    {/* <Table /> */}
                    <Detail/>
                    <PlaatsDetailplanning/>
                </div>
            </div>
        );
    }
}

export default Measures;
